import { ApiParameter, get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";

// Credit limit parameters to send
export interface ReleaseCreditLimit extends ApiParameter, HasPagingParameters {
    customerid: string | "";
    ApiKey: string | "";
    ApiURL: string | "";
}

// Credit limit parameters in response
export interface CreditParameter {
    data: string;
    succeeded: boolean;
}

export async function getActiveCardLimit(parameter: ReleaseCreditLimit) {
    const urlGetCreditLimit = `${parameter.ApiURL}?customerid=${parameter.customerid}`;

    const requestOptions = {
        method: "GET",
        headers: {
            "x-api-key": parameter.ApiKey,
            "Content-Type": "application/json",
        },
    };

    const responseData = await fetch(urlGetCreditLimit, requestOptions)
        .then(response => response.json())
        .then(data => data as CreditParameter);

    return responseData;
}
